module.exports = __webpack_public_path__ + "static/media/no-img.b6681619.png";